import { Loading } from '@components/Loading'

const SuspenseLoader = () => (
	<Loading noWrapper={false} backdrop containerHeight="100vh" />
)

export { SuspenseLoader }
